<div class="password-field">
  <div class="password-field__field">
    <label [for]="'password-' + passwordLabel"
      >{{ passwordLabel }}
      @if (required) {
        *
      }
    </label>
    <div class="password-field__input-wrapper">
      <input
        kendoTextBox
        [id]="'password-' + passwordLabel"
        [type]="showPassword ? 'text' : 'password'"
        [placeholder]="passwordPlaceholder"
        [value]="password"
        (input)="onPasswordInput($event)"
        (blur)="validatePassword()"
        class="password-field__input"
      />
      <button
        type="button"
        class="password-field__toggle"
        (click)="togglePasswordVisibility()"
        [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
      >
        <kendo-svg-icon [icon]="showPassword ? eyeSlashIconSvg : eyeIconSvg"></kendo-svg-icon>
      </button>
    </div>
    @if (showPasswordStrength && password) {
      <app-password-strength-meter
        [password]="password"
        [enableFeedback]="true"
      ></app-password-strength-meter>
    }
    @if (passwordError) {
      <span class="password-field__error">{{ passwordError }}</span>
    }
  </div>

  <div class="password-field__field">
    <label [for]="'confirmPassword-' + confirmPasswordLabel"
      >{{ confirmPasswordLabel }}
      @if (required) {
        *
      }
    </label>
    <div class="password-field__input-wrapper">
      <input
        kendoTextBox
        [id]="'confirmPassword-' + confirmPasswordLabel"
        [type]="showConfirmPassword ? 'text' : 'password'"
        [placeholder]="confirmPasswordPlaceholder"
        [value]="confirmPassword"
        (input)="onConfirmPasswordInput($event)"
        (blur)="validateConfirmPassword()"
        class="password-field__input"
      />
      <button
        type="button"
        class="password-field__toggle"
        (click)="toggleConfirmPasswordVisibility()"
        [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'"
      >
        <kendo-svg-icon
          [icon]="showConfirmPassword ? eyeSlashIconSvg : eyeIconSvg"
        ></kendo-svg-icon>
      </button>
    </div>
    @if (confirmPasswordError) {
      <span class="password-field__error">{{ confirmPasswordError }}</span>
    }
  </div>
</div>
